import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useSearch } from '@contexts/search-context';
import { useIsHydrated } from '@hooks';
import dayjs from '@utils/dayjs-setup';
import { AnalyticsRef } from '@components/analytics-ref';
import { ButtonIcon } from '@components/button-icon';
import { IconNames } from '@components/icon';
import { extractFirstPhraseBeforeComma } from '@utils/extract-first-phrase-before-comma';
import { guestDescription } from '@utils/guest-description';
interface SearchMobileBarProps {
  placeName: string | undefined;
}
export const SearchMobileBar: React.FC<SearchMobileBarProps> = t0 => {
  const $ = _c(28);
  const {
    placeName
  } = t0;
  const {
    activateFeaturesModal,
    activateMobileSearchModal,
    checkInDate,
    checkOutDate,
    adultCount,
    childCount,
    infantCount,
    petCount
  } = useSearch();
  const isHydrated = useIsHydrated();
  let t1;
  if ($[0] !== checkInDate || $[1] !== checkOutDate || $[2] !== isHydrated) {
    t1 = isHydrated && checkInDate && checkOutDate ? dayjs.utc(checkInDate).month() === dayjs.utc(checkOutDate).month() ? `${dayjs.utc(checkInDate).format("MMM D")} - ${dayjs.utc(checkOutDate).format("D")}` : `${dayjs.utc(checkInDate).format("MMM D")} - ${dayjs.utc(checkOutDate).format("MMM D")}` : "Add dates";
    $[0] = checkInDate;
    $[1] = checkOutDate;
    $[2] = isHydrated;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const dates = t1;
  let t2;
  if ($[4] !== adultCount || $[5] !== childCount || $[6] !== infantCount || $[7] !== isHydrated || $[8] !== petCount) {
    t2 = isHydrated && guestDescription(adultCount, childCount, infantCount, petCount) || "Add guests";
    $[4] = adultCount;
    $[5] = childCount;
    $[6] = infantCount;
    $[7] = isHydrated;
    $[8] = petCount;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const guests = t2;
  const t3 = placeName || "Map Search";
  let t4;
  if ($[10] !== t3) {
    t4 = extractFirstPhraseBeforeComma(t3);
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="w-full border-r-2 border-gray-light px-2 sm:max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== dates) {
    t6 = <div className="w-full border-r-2 border-gray-light px-2 sm:max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{dates}</div>;
    $[14] = dates;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== guests) {
    t7 = <div className="w-full pl-2 pr-4 sm:max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{guests}</div>;
    $[16] = guests;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== activateMobileSearchModal || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <button type="button" aria-label="Edit search" className="hover:shadow-md shadow-sm grid grid-cols-3 w-full rounded-full h-[48px] px-1.5 text-primary-main font-medium text-xs border-[1.5px] border-gray-light items-center sm:text-sm sm:max-w-xl justify-between" onClick={activateMobileSearchModal}>{t5}{t6}{t7}</button>;
    $[18] = activateMobileSearchModal;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== activateFeaturesModal) {
    t9 = <AnalyticsRef name="select_search_filters"><ButtonIcon icon={IconNames.FILTER} iconSize="xs" ariaLabel="Filters" variant="outlined" isCircle={true} isFullWidth={true} className="focus:outline-none h-9 w-9 mb-0.5" data-testid="@filters/filters-btn" onClick={activateFeaturesModal} /></AnalyticsRef>;
    $[23] = activateFeaturesModal;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <div className="absolute block w-full p-4"><div className="flex flex-row w-full items-center justify-center space-x-1.5 px-2 lg:hidden">{t8}{t9}</div></div>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};